import { defaultClauseStatus, PromptsForFeature } from "../constants";
import { ADMIN_ACTIONS } from "./admin.thunk";

interface AdminSliceProps {
  [key: string]: {
    loading?: boolean;
    error?: {};
    data?: [];
  };
  roleManagementData: any;
}

const initialState: AdminSliceProps = {
  [PromptsForFeature.CLAUSE_CHECK]: {},
  [PromptsForFeature.CONTRACT_REVIEW]: {},
  [PromptsForFeature.TALK_TO_CONTRACT]: {},
  roleManagementData: {},
};

export default function adminReducer(state = initialState, action: any) {
  switch (action.type) {
    case ADMIN_ACTIONS.GET_PROMPTS:
      var feature = action.payload?.feature;
      state = {
        ...state,
        [feature]: {
          ...state[feature],
          ...action.payload.data,
        },
      };
      return state;

    case ADMIN_ACTIONS.UPDATE_CLAUSE:
      feature = action.payload?.feature;
      var name = action.payload?.name;
      var value = action.payload?.value;

      const featureData: any = state?.[feature]?.data?.slice() || [];
      const clauseIdx = featureData?.findIndex(
        (clause: any) => clause?.id === action?.payload?.clauseId
      );

      if (clauseIdx > -1) {
        const rulesCopy = featureData[clauseIdx]?.rules?.slice();
        const ruleIdx = rulesCopy?.findIndex(
          (rule: any) => rule?.name === name
        );

        if (ruleIdx > -1) {
          rulesCopy[ruleIdx] = {
            ...rulesCopy[ruleIdx],
            count: value,
          };

          featureData[clauseIdx] = {
            ...featureData[clauseIdx],
            rules: rulesCopy,
          };
        }
      }

      state = {
        ...state,
        [feature]: {
          ...state[feature],
          data: featureData,
        },
      };

      return state;

    case ADMIN_ACTIONS.ADD_NEW_KEYWORD_SECTION_FOR_TTC:
      const data: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCopy = data?.[0]?.rules?.slice();
      rulesCopy?.unshift(action.payload.prompt);

      const newData = {
        ...data[0],
        rules: rulesCopy,
      };

      data[0] = newData;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: data,
        },
      };

      return state;

    case ADMIN_ACTIONS.SAVE_NEW_SYNONYM_FOR_TTC:
      const idx = action.payload?.idx;
      const dataCopy: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCp = dataCopy?.[0]?.rules?.slice();

      rulesCp[idx] = action.payload?.data;

      const newDataObj = {
        ...dataCopy[0],
        rules: rulesCp,
      };

      dataCopy[0] = newDataObj;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: dataCopy,
        },
      };

      return state;

    case ADMIN_ACTIONS.DELETE_KEYWORD_SECTION_FOR_TTC:
      const idx1 = action.payload?.keywordId;
      const dataCopy1: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCp1 = dataCopy1?.[0]?.rules?.slice();
      rulesCp1?.splice(idx1, 1);

      const newDataObj1 = {
        ...dataCopy1[0],
        rules: rulesCp1,
      };

      dataCopy1[0] = newDataObj1;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: dataCopy1,
        },
      };
      return state;

    case ADMIN_ACTIONS.REMOVE_KEYWORDS_WITH_NEW_KEYWORD_TYPE:
      const dataCopy2: any =
        state?.[PromptsForFeature.TALK_TO_CONTRACT]?.data?.slice();
      const rulesCp2 = dataCopy2?.[0]?.rules?.slice();
      const defaultRules = rulesCp2?.filter(
        (rule: any) => rule?.type === defaultClauseStatus.DEFAULT
      );

      const newDataObj2 = {
        ...dataCopy2[0],
        rules: defaultRules,
      };

      dataCopy2[0] = newDataObj2;

      state = {
        ...state,
        [PromptsForFeature.TALK_TO_CONTRACT]: {
          ...state[PromptsForFeature.TALK_TO_CONTRACT],
          data: dataCopy2,
        },
      };

      return state;

    case ADMIN_ACTIONS.SET_ROLE_MANAGE_DATA:
      state = {
        ...state,
        roleManagementData: {
          ...state.roleManagementData,
          ...action.payload,
        },
      };

      return state;
    default:
      return state;
  }
}
